import { httpRegex, numbersRegex } from '@hilma/netina2all';
import { isNumberString, isURL } from 'class-validator';
import { createRules } from '../../functions';

export const AssociationApprovedRules = createRules({
	image: { required: true },
	receipt: { required: false, accept: ['application/pdf'] },
	goalKits: { required: false, classValidator: (value: string) => isNumberString(value), activeRegex: numbersRegex, greaterThan: 0 },
	website: { name: 'האתר', required: true, classValidator: (value: string) => isURL(value), regex: httpRegex, activeRegex: httpRegex, activeRegexErr: 'חייב להתחיל ב //:https או //:http' },
});